export interface Result<T, U extends Error | undefined> {
    readonly result: T | never;
    readonly error: U | undefined;
}

class OkResult<T> implements Result<T, Error> {
    constructor(private readonly value: T) {}

    get result(): T {
        return this.value;
    }

    get error(): undefined {
        return undefined;
    }
}

class ErrorResult<E extends Error> implements Result<any, E> {
    constructor(private readonly err: E) {}

    get result(): undefined {
        return undefined;
    }

    get error(): E {
        return this.err;
    }

}

export function Ok<T>(value: T): Result<T, undefined> {
    return new OkResult(value);
}

export function Err<E extends Error>(error: E): Result<any, E> {
    return new ErrorResult(error);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./node_modules/sensejs/core/result.ts